var map = {
	"./0001_marvel-snap-07-12-2025.json": 681,
	"./0002_04-2025.json": 8262,
	"./0003_article-3.json": 4787,
	"./0004_marvel-snap-23-11-2025.json": 9965,
	"./0005_20-2025.json": 1229,
	"./0006_marvel-snap.json": 3272,
	"./0007_18-2025.json": 3054,
	"./0008_marvel-snap-09-11-2025.json": 5177,
	"./0009_06-2025.json": 8917,
	"./0010_marvel-snap-02-11-2025.json": 4947,
	"./0011_article-11.json": 2313,
	"./0012_30-2025.json": 2218,
	"./0013_marvel-snap-26-10-2025.json": 4363,
	"./0014_smlz.json": 4341,
	"./0015_article-15.json": 7049,
	"./0016_marvel-snap-20-10-2025.json": 304,
	"./0017_16-2025.json": 3845,
	"./0018_14-2025.json": 5922,
	"./0019_marvel-snap-12-10-2025.json": 3318,
	"./0020_article-20.json": 9761,
	"./0021_article-21.json": 6755,
	"./0022_marvel-snap-05-10-2025.json": 2176,
	"./0023_article-23.json": 7651,
	"./0024_marvel-snap-27-09-2025.json": 2756,
	"./0025_team-ups.json": 4913,
	"./0026_25-2025.json": 2443,
	"./0027_marvel-snap-20-09-2025.json": 8322,
	"./0028_16-2025-2.json": 6660,
	"./0029_marvel-snap-14-09-2025.json": 2867,
	"./0030_11-2025.json": 4633,
	"./0031_marvel-snap-07-09-2025.json": 1908,
	"./0032_marvel-snap-31-08-2025.json": 1275,
	"./0033_marvel-snap-16-08-2025.json": 8577,
	"./0034_article-34.json": 9759,
	"./0035_28-2025.json": 722,
	"./0036_19-2025.json": 8491,
	"./0037_14-2025-2.json": 8574,
	"./0038_article-38.json": 4295,
	"./0039_31-2025.json": 5460,
	"./0040_article-40.json": 8317,
	"./0041_17-2025.json": 3871,
	"./0042_17-2025-2.json": 2729,
	"./0043_marvel-snap-08-07-2025-15-07-2025.json": 4419,
	"./0044_marvel-snap-2.json": 5273,
	"./0045_article-45.json": 9431,
	"./0046_marvel-snap-01-07-2025-08-07-2025.json": 8951,
	"./0047_clea.json": 2490,
	"./0048_marvel-snap-23-06-2025-30-06-2025.json": 9040,
	"./0049_26-2025.json": 8687,
	"./0050_dormammu.json": 5499,
	"./0051_24-2025.json": 8284,
	"./0052_kid-omega.json": 9329,
	"./0053_marvel-snap-09-06-2025-22-06-2025.json": 3259,
	"./0054_second-dinner.json": 2498,
	"./0055_article-55.json": 4889,
	"./0056_article-56.json": 8123,
	"./0057_10-2025.json": 7707,
	"./0058_marvel-snap-02-06-2025-08-06-2025.json": 3169,
	"./0059_5-2025.json": 3959,
	"./0060_article-60.json": 1833,
	"./0061_article-61.json": 6707,
	"./0062_3-2025.json": 4435,
	"./0063_29-2025.json": 4168,
	"./0064_article-64.json": 6113,
	"./0065_marvel-snap-19-05-2025-25-05-2025.json": 4034,
	"./0066_article-66.json": 9245,
	"./0067_marvel-snap-12-05-2025-18-05-2025.json": 2407,
	"./0068_article-68.json": 9929,
	"./0069_marvel-snap-05-05-2025-11-05-2025.json": 6162,
	"./0070_article-70.json": 2719,
	"./0071_article-71.json": 3993,
	"./0072_article-72.json": 3027,
	"./0073_marvel-snap-28-04-2025-04-05-2025.json": 6911,
	"./0074_fan-fei-batroc-the-leaper-topaz-4.json": 5789,
	"./0075_snap.json": 5536,
	"./0076_snap-2.json": 9944,
	"./0077_29-2025-2.json": 1478,
	"./0078_marvel-snap-21-04-2025-27-04-2025.json": 6481,
	"./0079_article-79.json": 8457,
	"./0080_24.json": 4302,
	"./0081_article-81.json": 3415,
	"./0082_article-82.json": 6529,
	"./0083_article-83.json": 9023,
	"./0084_marvel-snap-3.json": 5834,
	"./0085_article-85.json": 9423,
	"./0086_article-86.json": 8041,
	"./0087_article-87.json": 3335,
	"./0088_marvel-snap-2024.json": 5901,
	"./0089_article-89.json": 5431,
	"./0090_30-2024.json": 1919,
	"./0091_10-2024.json": 5438,
	"./0092_snap-3.json": 961,
	"./0093_article-93.json": 1897,
	"./0094_10.json": 2782,
	"./0095_marvel-snap-4.json": 4857,
	"./0096_10-marvel-snap.json": 2763,
	"./0097_5-2024.json": 5138,
	"./0098_article-98.json": 4095,
	"./0099_marvel-snap-5.json": 8138,
	"./0100_article-100.json": 5815,
	"./0101_article-101.json": 6131,
	"./0102_article-102.json": 5699,
	"./0103_article-103.json": 5447,
	"./0104_article-104.json": 6935,
	"./0105_article-105.json": 923,
	"./0106_2024.json": 6539,
	"./0107_article-107.json": 4807,
	"./0108_article-108.json": 8839,
	"./0109_2023-2024.json": 4580,
	"./0110_article-110.json": 6331,
	"./0111_19-2023.json": 9797,
	"./0112_article-112.json": 9827,
	"./0113_article-113.json": 2419,
	"./0114_article-114.json": 355,
	"./0115_discord-nitro.json": 9856,
	"./0116_marvel-snap-6.json": 6641,
	"./0117_article-117.json": 5403,
	"./0118_marvel-snap-7.json": 8852,
	"./0119_article-119.json": 4195,
	"./0120_article-120.json": 8439,
	"./0121_article-121.json": 3759,
	"./0122_gamescom-opening-night-live-2023.json": 8698,
	"./0123_marvel-snap-2023.json": 3648,
	"./0124_marvel-snap-8.json": 402,
	"./0125_article-125.json": 5751,
	"./0126_article-126.json": 4043,
	"./0127_marvel-snap-9.json": 6012,
	"./0128_article-128.json": 2263,
	"./0129_article-129.json": 1327,
	"./0130_marvel-snap-10.json": 9636,
	"./0131_marvel-snap-11.json": 1006,
	"./0132_article-132.json": 4827,
	"./0133_1-0.json": 4131,
	"./0134_1-2023.json": 6183,
	"./0135_article-135.json": 5367,
	"./0136_marvel-snap-jvke.json": 4788,
	"./0137_article-137.json": 1887,
	"./0138_10-2025-2.json": 100,
	"./0139_27-2025.json": 8246,
	"./0140_13-2025.json": 5907,
	"./0141_27-2025-2.json": 878,
	"./0142_13-2025-2.json": 694,
	"./0143_30-2025-2.json": 8028,
	"./0144_16-2025-3.json": 886,
	"./0145_12-2024.json": 9342,
	"./0146_14-2024.json": 121,
	"./0147_24-2024.json": 9823,
	"./0148_10-2024-2.json": 4016,
	"./0149_26-2024.json": 4723,
	"./0150_12-2024-2.json": 9059,
	"./0151_29-2024.json": 989,
	"./0152_15-2024.json": 1429,
	"./0153_1-2024.json": 115,
	"./0154_18-2024.json": 1514,
	"./0155_27-2024.json": 551,
	"./0156_13-2024.json": 3919,
	"./0157_23-2024.json": 2621,
	"./0158_9-2024.json": 7748,
	"./0159_25-2024.json": 6585,
	"./0160_4-2024.json": 6820,
	"./0161_21-2024.json": 9546,
	"./0162_29-2024-2.json": 5260,
	"./0163_1-2024-2.json": 7849,
	"./0164_18-2024-2.json": 1594,
	"./0165_21-2023.json": 5603,
	"./0166_9-2023.json": 7270,
	"./0167_26-2023.json": 5350,
	"./0168_28-2023.json": 8193,
	"./0169_14-2023.json": 7555,
	"./0170_31-2023.json": 8334,
	"./0171_17-2023.json": 1853,
	"./0172_3-2023.json": 6267,
	"./0173_20-2023.json": 8309,
	"./0174_22-2023.json": 8798,
	"./0175_8-2023.json": 747,
	"./0176_25-2023.json": 8587,
	"./0177_4-2023.json": 141,
	"./0178_9-2023-2.json": 2868,
	"./0179_1-2025.json": 512,
	"./0180_4-2025.json": 5805,
	"./0181_11-2025-2.json": 8085,
	"./0182_14-2025-3.json": 622,
	"./0183_10-2024-3.json": 8810,
	"./0184_12-2024-3.json": 2021,
	"./0185_15-2024-2.json": 974,
	"./0186_17-2024.json": 7830,
	"./0187_20-2024.json": 5551,
	"./0188_30-2024-2.json": 7450,
	"./0189_25-2024-2.json": 2675,
	"./0190_4-2024-2.json": 6542,
	"./0191_30-2024-3.json": 803,
	"./0192_9-2024-2.json": 3073,
	"./0193_12-2024-4.json": 2496,
	"./0194_6-2024.json": 7208,
	"./0195_9-2024-3.json": 9729,
	"./0196_5-2023.json": 7424,
	"./0197_31-2023-2.json": 5190,
	"./0198_3-2023-2.json": 2252,
	"./0199_5-2023-2.json": 2587,
	"./0200_8-2023-2.json": 911,
	"./0201_11-2023.json": 690,
	"./0202_13-2023.json": 7522,
	"./0203_16-2023.json": 4664,
	"./0204_18-2023.json": 787,
	"./0205_21-2023-2.json": 6139,
	"./0206_21-2023-3.json": 2089,
	"./0207_31-2023-3.json": 7505,
	"./0208_marvel-snap-faq.json": 6653,
	"./0209_article-209.json": 7299,
	"./0210_3.json": 4446,
	"./0211_article-211.json": 899,
	"./0212_article-212.json": 9715,
	"./0213_marvel-snap-12.json": 900,
	"./0214_marvel-snap-13.json": 7888,
	"./0215_marvel-snap-14.json": 420,
	"./0216_marvel-snap-15.json": 9872,
	"./0217_discord-18-10-2023.json": 4132,
	"./0218_discord-04-10-2023-1.json": 4776,
	"./0219_discord-04-10-2023-2.json": 4904,
	"./0220_discord-11-10-2023.json": 3441,
	"./0221_discord-23-08-2023.json": 1166,
	"./0222_discord-30-08-2023.json": 3325,
	"./0223_discord-06-09-2023.json": 56,
	"./0224_discord-13-09-2023.json": 6509,
	"./0225_discord-20-09-2023.json": 9994,
	"./0226_discord-27-09-2023.json": 6120,
	"./0227_article-227.json": 5583,
	"./0228_article-228.json": 4403,
	"./0229_marvel-snap-16.json": 5267,
	"./0230_article-230.json": 8231,
	"./0231_article-231.json": 683,
	"./0232_article-232.json": 3103,
	"./0233_article-233.json": 5027,
	"./0234_article-234.json": 4127,
	"./0235_article-235.json": 1531,
	"./0236_article-236.json": 8775,
	"./0237_article-237.json": 4867,
	"./0238_article-238.json": 1735,
	"./0239_article-239.json": 8091,
	"./0240_article-240.json": 2727,
	"./0241_article-241.json": 6603,
	"./0242_article-242.json": 7835,
	"./0243_article-243.json": 4767,
	"./0244_article-244.json": 8071,
	"./0245_article-245.json": 8531,
	"./0246_article-246.json": 2547,
	"./0247_article-247.json": 4335,
	"./0248_article-248.json": 5335,
	"./0249_article-249.json": 8779,
	"./0250_article-250.json": 9123,
	"./0251_article-251.json": 8987,
	"./0252_ii.json": 3813,
	"./0253_article-253.json": 979,
	"./0254_article-254.json": 7275,
	"./0255_article-255.json": 1795,
	"./0256_article-256.json": 5235,
	"./0257_marvel-rivals.json": 9337,
	"./0258_article-258.json": 1363,
	"./0259_article-259.json": 8379,
	"./0260_article-260.json": 315,
	"./0261_article-261.json": 8899,
	"./0262_article-262.json": 5863,
	"./0263_article-263.json": 615,
	"./0264_article-264.json": 5747,
	"./0265_article-265.json": 6555,
	"./0266_article-266.json": 4343,
	"./0267_article-267.json": 3975,
	"./0268_article-268.json": 4203,
	"./0269_article-269.json": 2147,
	"./0270_article-270.json": 2215,
	"./0271_article-271.json": 4928,
	"./0272_article-272.json": 4047,
	"./0273_article-273.json": 4915,
	"./0274_article-274.json": 3503,
	"./0275_article-275.json": 4819,
	"./0276_article-276.json": 9607,
	"./0277_article-277.json": 7267,
	"./0278_article-278.json": 4231,
	"./0279_article-279.json": 2435,
	"./0280_article-280.json": 4103,
	"./0281_article-281.json": 3539,
	"./0282_article-282.json": 1280,
	"./0283_article-283.json": 1863,
	"./0284_article-284.json": 1479,
	"./0285_article-285.json": 6251,
	"./0286_article-286.json": 5803,
	"./0287_article-287.json": 983,
	"./0288_article-288.json": 5223,
	"./0289_article-289.json": 8755,
	"./0290_article-290.json": 2395,
	"./0291_article-291.json": 9619,
	"./0292_article-292.json": 8067,
	"./0293_article-293.json": 547,
	"./0294_article-294.json": 8867,
	"./0295_article-295.json": 3179,
	"./0296_article-296.json": 3579,
	"./0297_article-297.json": 1691,
	"./0298_article-298.json": 427,
	"./0299_article-299.json": 6483,
	"./0300_article-300.json": 5139,
	"./0301_article-301.json": 6903,
	"./0302_article-302.json": 7463,
	"./0303_article-303.json": 6643,
	"./0304_article-304.json": 1323,
	"./0305_article-305.json": 9095,
	"./0306_article-306.json": 1799,
	"./0307_article-307.json": 6907,
	"./0308_article-308.json": 3923,
	"./0309_article-309.json": 7943,
	"./0310_article-310.json": 7187,
	"./0311_article-311.json": 1939,
	"./0312_article-312.json": 947,
	"./0313_article-313.json": 9755,
	"./0314_article-314.json": 3987,
	"./0315_article-315.json": 1043,
	"./0316_article-316.json": 912,
	"./0317_article-317.json": 9051,
	"./0318_article-318.json": 4800,
	"./0319_article-319.json": 4483,
	"./0320_article-320.json": 2915,
	"./0321_article-321.json": 707,
	"./0322_article-322.json": 5484,
	"./0323_article-323.json": 6607,
	"./0324_article-324.json": 9891,
	"./0325_article-325.json": 3769,
	"./0326_article-326.json": 2535,
	"./0327_article-327.json": 6039,
	"./0328_article-328.json": 8131,
	"./0329_article-329.json": 8035,
	"./0330_article-330.json": 7155,
	"./0331_article-331.json": 8975,
	"./0332_article-332.json": 7091,
	"./0333_article-333.json": 7759,
	"./0334_article-334.json": 4137,
	"./0335_article-335.json": 6071,
	"./0336_2024-2.json": 1775,
	"./0337_marvel-snap-17.json": 5608,
	"./0338_1.json": 3697,
	"./0339_2.json": 4495,
	"./0340_marvel-snap-18.json": 6047,
	"./0341_article-341.json": 1007,
	"./0342_2024-3.json": 5277,
	"./0343_2024-4.json": 4257,
	"./0344_2024-5.json": 9357,
	"./0345_2024-6.json": 5545
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3330;